import { render, staticRenderFns } from "./MultilineText.vue?vue&type=template&id=814ac9a8&scoped=true&"
import script from "./MultilineText.vue?vue&type=script&lang=js&"
export * from "./MultilineText.vue?vue&type=script&lang=js&"
import style0 from "./MultilineText.vue?vue&type=style&index=0&id=814ac9a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814ac9a8",
  null
  
)

export default component.exports